// Service catalog (mirrors backend SERVICES dict and Stripe lookup keys)
import {
    Sparkles,
    Briefcase,
    Heart,
    Users,
    Baby,
    Building2,
    Home as HomeIcon,
    Activity,
    Plane,
    Hash,
    CalendarRange,
    Clock4,
    Flame,
    TrendingUp,
} from "lucide-react";

export const SERVICES = [
    {
        slug: "karma-guide",
        name: "Karma Guide Astrology",
        priceInr: 5100,
        duration: "45 min",
        icon: Flame,
        tag: "Signature",
        blurb: "Read the karmic blueprint of this lifetime — past-life patterns, soul lessons, dharma path, and conscious remedies.",
    },
    {
        slug: "financial-astrology",
        name: "Financial Astrology",
        priceInr: 5100,
        duration: "45 min",
        icon: TrendingUp,
        tag: "New",
        blurb: "Wealth yogas, investment timing, debt patterns and dasha windows for income surges — practical money guidance from your chart.",
    },
    {
        slug: "birth-chart-reading",
        name: "Birth Chart Reading",
        priceInr: 11000,
        duration: "45 min",
        icon: Sparkles,
        tag: "Most popular",
        blurb: "Decode your kundli's secret architecture — planets, houses, dashas, and your soul's blueprint.",
    },
    {
        slug: "career-consultation",
        name: "Career Consultation",
        priceInr: 5100,
        duration: "45 min",
        icon: Briefcase,
        blurb: "Career direction, job change timing, promotion windows, and dasha-based growth phases.",
    },
    {
        slug: "marriage-consultation",
        name: "Marriage Consultation",
        priceInr: 3100,
        duration: "45 min",
        icon: Heart,
        blurb: "Kundli milan, Manglik analysis, doshas, and timing of marriage with remedies.",
    },
    {
        slug: "relationship-problems",
        name: "Relationship Problems",
        priceInr: 5100,
        duration: "45 min",
        icon: Users,
        blurb: "Conflict resolution, compatibility scan, and karmic patterns shaping the bond.",
    },
    {
        slug: "child-birth",
        name: "Child Birth Consultation",
        priceInr: 5100,
        duration: "45 min",
        icon: Baby,
        blurb: "Putra-yog analysis, timing of conception, and supportive remedies for parenthood.",
    },
    {
        slug: "business-astrology",
        name: "Business Astrology",
        priceInr: 5100,
        duration: "45 min",
        icon: Building2,
        tag: "Premium",
        blurb: "Business name correction, partnership analysis, launch muhurat, and growth strategy.",
    },
    {
        slug: "property-astrology",
        name: "Property Astrology",
        priceInr: 3100,
        duration: "45 min",
        icon: HomeIcon,
        blurb: "Best timing to buy, sell, or invest in property — plus vaastu pointers from your chart.",
    },
    {
        slug: "health-astrology",
        name: "Health Astrology",
        priceInr: 3100,
        duration: "45 min",
        icon: Activity,
        blurb: "Health vulnerabilities by house, recurring patterns, and supportive lifestyle remedies.",
    },
    {
        slug: "foreign-settlement",
        name: "Foreign Settlement",
        priceInr: 5100,
        duration: "45 min",
        icon: Plane,
        blurb: "Visa timing, country compatibility, and the dasha windows opening migration paths.",
    },
    {
        slug: "numerology",
        name: "Numerology Consultation",
        priceInr: 3100,
        duration: "30 min",
        icon: Hash,
        blurb: "Life path, name vibration, business name corrections — Chaldean methodology.",
    },
    {
        slug: "annual-horoscope",
        name: "Annual Horoscope",
        priceInr: 31000,
        duration: "45 min",
        icon: CalendarRange,
        tag: "Best value",
        blurb: "A complete year-ahead roadmap — career, relationships, finance, health, and dharma.",
    },
    {
        slug: "muhurat",
        name: "Muhurat Consultation",
        priceInr: 2100,
        duration: "30 min",
        icon: Clock4,
        blurb: "Auspicious timing for marriage, griha pravesh, vehicle, business launch, or surgery.",
    },
];

export const SERVICE_BY_SLUG = Object.fromEntries(SERVICES.map((s) => [s.slug, s]));

export const FAQS = [
    {
        q: "How do online consultations work?",
        a: "After booking & payment, you'll receive a confirmation with the Google Meet / Zoom link via email and WhatsApp. Sessions are 1-on-1, voice or video, in English or Hindi.",
    },
    {
        q: "Which astrology system do you use?",
        a: "We primarily use Vedic Astrology (Jyotish) with deep specialization in Bhrigu Nandi Nadi (BNN). For numerology, we follow the Chaldean system.",
    },
    {
        q: "What birth details are required?",
        a: "Date of birth, exact time of birth (as accurate as possible), and place of birth. If birth time is unknown, mention it — we use rectification techniques.",
    },
    {
        q: "How long is the consultation?",
        a: "Sessions range 30 to 45 minutes depending on the service. Premium services like Annual Horoscope run 45 minutes with a written summary follow-up.",
    },
    {
        q: "Can international clients book?",
        a: "Absolutely. Dr. Tannu serves clients in 25+ countries. Sessions are conducted online in your local time zone. Payments are accepted in INR via Stripe (cards from any country).",
    },
    {
        q: "Are sessions confidential?",
        a: "Yes — all sessions and shared details are strictly confidential. We follow a GDPR-aligned privacy practice.",
    },
    {
        q: "Do you offer refunds?",
        a: "If you cancel 24+ hours before your slot, you'll receive a full refund or free reschedule. No-shows are non-refundable.",
    },
    {
        q: "What about remedies — gemstones, mantras, donations?",
        a: "Remedies suggested are simple, ethical, and chart-specific. We never recommend expensive gemstones without rigorous chart justification.",
    },
];

export const BLOG_CATEGORIES = [
    "All",
    "Vedic Astrology",
    "Numerology",
    "Planetary Transits",
    "Horoscope",
    "Remedies",
    "Panchang",
    "Nakshatras",
];

export const COUNTRIES = [
    "India", "United States", "United Kingdom", "Canada", "Australia", "United Arab Emirates",
    "Singapore", "New Zealand", "Germany", "France", "Netherlands", "Switzerland", "Ireland",
    "Saudi Arabia", "Qatar", "Bahrain", "Kuwait", "Oman", "Nepal", "Sri Lanka", "Other",
];

export const TIME_SLOTS = [
    "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
    "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM",
    "06:00 PM", "07:00 PM", "08:00 PM",
];

export const WHATSAPP_NUMBER = "919871178773";
export const WHATSAPP_MESSAGE = "Namaste! I would like to book a consultation with Dr. Tannu Aggarwal.";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

// Robust opener — bypasses iframe / popup-blocker quirks and supports right-click.
export const openWhatsApp = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const url = WHATSAPP_LINK;
    // Try named window first (allows app preview iframes to break out)
    const win = window.open(url, "_blank", "noopener,noreferrer");
    if (!win) {
        // Popup blocked — fall back to top-level navigation
        try { window.top.location.href = url; } catch { window.location.href = url; }
    }
};

export const INSTAGRAM = "https://instagram.com/vedicvisionaries";
export const FACEBOOK  = "https://facebook.com/vedicvisionaries";
export const YOUTUBE   = "https://youtube.com/@vedicvisionaries";
